import React from "react";
import { DownloadIcon } from "lucide-react";
import styles from "./DeviceStateCard.module.css";
import TCUStyles from "../../TCU.module.css";
import DeviceStateCityTable from "./DeviceStateCityTable";
import { useLatencyContextData } from "../context/Context";
import useApiRows from "../useApiRows";
import { LATENCY_DOWNLOAD_APIS, downloadCsv, getDeviceStateCityTable } from "../LatencyService";

/* ============================ MAIN ============================ */
export default function DeviceStateCard({ title = "Device Health" }) {
    const { GlobalFilter } = useLatencyContextData();

    // city-wise rows for the switch combination; loaded here so the download icon can disable on no data
    const [cityRows, isLoading] = useApiRows(getDeviceStateCityTable, { ...GlobalFilter });

    const scope = GlobalFilter?.search?.length
        ? `VIN: ${GlobalFilter.search.join(", ")}`
        : "Fleet";

    return (
        <div className={`card ${styles.card} mx-3 mt-2 mb-2`}>
            <div className="d-flex justify-content-between align-items-center flex-wrap mb-1">
                <div className={TCUStyles.titleWrap}>
                    <span className={TCUStyles.titleBar} />
                    <span className={TCUStyles.title}>{title}</span>
                    <span className={TCUStyles.subtitle}>
                        {scope} · Flip the status switches in the header; click a city to view its depots, a depot to view its vehicles
                    </span>
                </div>

                <button
                    type="button"
                    className={`${TCUStyles.downloadBtn} custom-Btn-animation`}
                    title="Download device health (CSV)"
                    disabled={isLoading || !cityRows.length}
                    onClick={() =>
                        downloadCsv(LATENCY_DOWNLOAD_APIS.deviceHealth, { ...GlobalFilter }, title).catch(() => { })
                    }
                >
                    <DownloadIcon size={15} />
                </button>
            </div>

            <DeviceStateCityTable cityRows={cityRows} isLoading={isLoading} />
        </div>
    );
}
